const routeConstant = {
  LOGIN: "/login",
  RMS_LOGIN: "/rmslogin",
  RMS_SIGNUP: "/rmssignUp",
  SCHEDULE: "/schedule",
  SEARCH_RESULT: "/searchResults",
  BLOGS: "/blogs",
  BLOGS_DETAILS: "/blogsDetail",
  UPDATE_PASSWORD: "/updatePassword",
  SCHEDULE_SIGNUP: "/signUp",
  SCHEDULE_FORGOT_PASSWORD: "/scheduleForgotPassword",
  SCHEDULE_LOGIN: "/scheduleLogin",
  STATEMENT: "/statements",
  DASHBOARD: "/shipments/analytics",
  SHIPMENT: "/shipments/listing",
  SHIPMENT_REPORT: "/shipments/report",
  SHIPMENTCO2_REPORT: "/shipments/co2report",
  FORGOTPASSWORD: "/forgot-password",
  RESET_PASSWORD_LINK: "/resetPassword/:id",
  INSURANCE: "/cargo-insurance",

  // UserList: "/UserList",

  //Oms routes
  APP: "/",
  // LOGIN: "/auth/login",
  RESETPASSWORD: "/auth/login/resetPassword",
  // FORGOTPASSWORD: "/auth/login/forgotPassword",
  SIGNUP: "/auth/signup",
  CHANGEPASSWORD: "/changePassword",
  PROFILE: "/profile",
  CREATE_ORDER_MAIN: "/create-order",
  CREATE_ORDER: "/create-order/order-specifcs",

  LINE_DETAIL: "/create-order/line-details",

  ORDER_PLAN: "/create-order/order-plan",
  DOC_UPLOAD: "/create-order/e-doc-upload",
  CONFIRMATION: "/create-order/confirmation",

  //dashoard list edit routes
  EDIT_CREATE_ORDER_MAIN: "/edit-order",
  // CREATE_ORDER_MAIN_SIDEBAR: "/create-order",
  EDIT_CREATE_ORDER: "/dashboard/edit-order/order-specifcs",
  EDIT_LINE_DETAIL: "/dashboard/edit-order/line-details",
  EDIT_ORDER_PLAN: "/dashboard/edit-order/order-plan",
  EDIT_DOC_UPLOAD: "/dashboard/edit-order/e-doc-upload",
  EDIT_CONFIRMATION: "/dashboard/edit-order/confirmation",

  //order list edit routes
  // LIST_EDIT_CREATE_ORDER_MAIN: "/edit-order",
  // EDIT_ORDER_ORDER: "/dashboard/edit-order/order-specifcs",
  LIST_EDIT_CREATE_ORDER: "/order-list/edit-order/order-specifcs",
  LIST_EDIT_LINE_DETAIL: "/order-list/edit-order/line-details",
  LIST_EDIT_ORDER_PLAN: "/order-list/edit-order/order-plan",
  LIST_EDIT_DOC_UPLOAD: "/order-list/edit-order/e-doc-upload",
  LIST_EDIT_CONFIRMATION: "/order-list/edit-order/confirmation",

  ORDER_DASHBOARD: "/dashboard",
  ORDER_LIST: "/order-list",
  ORDER_LIST_PLACED: "/order-list/placed",
  ORDER_LIST_APPROVED: "/order-list/approved",
  ORDER_LIST_ARCHIVE: "/order-list/archived",
  ORDER_LIST_LOADED: "/order-list/loaded",
  ORDER_LIST_REJECTED: "/order-list/cancelled",
  ORDER_LIST_FULL: "/order-list/details",
  DASH_ORDER_LIST_FULL: "/dashboard/details",
  ORDER_LIST_FULL_LOG: "/order-list/details/log",
  DASH_ORDER_LIST_FULL_LOG: "/dashboard/details/log",

  ORDER_LIST_FULL_MILESTONE: "/order-list/details/milestone",
  ORDER_LIST_FULL_MILESTONE_DASH: "/dashboard/details/milestone",

  SYSTEM_LOG: "/system-log",
  ORDER_REPORT: "/order-report",
  SETTINGS: "/settings",
  REPORTS: "/reports",
  ORDER_MAIN: "/",
  CHAT: "/chat",
  HELP: "/help",
  USERS: "/users",
  CREATE_USER: "/create-users",
  NOTIFICATION: "/notification",
  NOTIFICATION_EDIT: "/notification/edit",
  // RMS
  COST: "/cost",
  SELL: "/sell",
  QUOTE: "/quote",
  LCL: "/lcl",
  FCL: "/fcl",
  LCL_CREATE_QUOTE: "/lcl/create",
  FCL_CREATE_QUOTE: "/fcl/create",
  FCL_QUOTE_DETAILS: "/fcl/quote/details",
  CREATEQUOTE: "/quote/create",
  QUOTEDETAILS: "/quote/details",
  // self
  PERMISSION: "/permission",
  CREATE_NEW: "/create-new",
};

export default routeConstant;
